import 'whatwg-fetch';
const env = process.env;

const getConsumablesStatus = (payload) => {
    return fetch(`${env.VUE_APP_trimaster}/api/v1/ag_facilityConsumablesStatuses?access_token=${payload.apitoken}&filter=${payload.filters}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json'
		}
	});
}

export default {
  getConsumablesStatus
}
